import { useTerms } from "@/lib/api/terms/hooks";
import { Header } from "@/components/shared/header";
import { PageContainer } from "@/components/shared/page-container";
import { AdminGuard } from "@/components/shared/admin-guard";
import { LoadingSkeleton } from "@/components/shared/loading-skeleton";
import { useLoadingIndicator } from "@/lib/hooks/use-loading-indicator";
import { Link, createFileRoute } from "@tanstack/react-router";
import { ChevronRight } from "lucide-react";

function TermsPage() {
  const { data: terms, isLoading } = useTerms();

  useLoadingIndicator(isLoading);

  return (
    <AdminGuard>
      <PageContainer>
        <Header title="약관 관리" />

        <div className="flex flex-col gap-2">
          <LoadingSkeleton className="w-full h-20" isLoading={isLoading}>
            {terms?.map((term) => (
              <Link
                key={term.slug}
                to="/terms/$slug/edit"
                params={{ slug: term.slug }}
                className="flex items-center justify-between p-4 border rounded-lg hover:bg-muted transition-colors"
              >
                <div>
                  <h3 className="font-medium">{term.title}</h3>
                  <p className="text-sm text-muted-foreground">{term.slug}</p>
                </div>
                <ChevronRight className="size-5 text-muted-foreground" />
              </Link>
            ))}
          </LoadingSkeleton>
        </div>
      </PageContainer>
    </AdminGuard>
  );
}

export const Route = createFileRoute("/_content/terms/")({
  component: TermsPage,
});
